import React , {Component} from 'react';
import './SubMenuCards.css';
import CarriculamTable from './CarriculamTable'
import ImageComponent from './ImageComponent'
import { makeStyles } from '@material-ui/core/styles';
import Carousel, { consts } from 'react-elastic-carousel';
import { Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
    },
}));

const cardStyle = {
    width: "5rem",
    height: "5rem",
    background: "red",
    margin: "1rem"
};

const cardSelect = {
    boxShadow: "2px 4px 30px 0px rgba(0, 0, 0, 0.75)"
};

class SubMenuCards extends Component {
    myArrow({ type, onClick, isEdge }) {
        const pointer = type === consts.PREV ? '<' : '>'
        return (
            <Button onClick={onClick} disabled={isEdge}>
                {pointer}
            </Button>
        )
    }
    constructor(props) {
        const defval = props.streams[0];
        super(props);
        this.state = {
            IsActive: true,
            ImageUrl: defval.ImageUrl,
            ImageUrlm2: defval.ImageUrlm2,
            tectDuration: defval.TechDuration,
            learningFormat: defval.LearningFor,
            assessmentPatt: defval.AssessmentPatt,
            learningFormatm2: defval.LearningForm2,
            assessmentPattm2: defval.AssessmentPattm2,
            carriculamTables: defval.CarriculamTables,
            selectedIndex: props.AccordName
        };
    }
    showAlert(e, link) {
        e.preventDefault();
        const ul = this.props.streams.filter((p) => p.Stream === link)[0];//.ImageUrl;
        this.setState({ IsActive: false });
        setTimeout(() => {
            this.setState({
                IsActive: true,
                ImageUrl: ul.ImageUrl,
                ImageUrlm2: ul.ImageUrlm2,
                tectDuration: ul.TechDuration,
                learningFormat: ul.LearningFor,
                assessmentPatt: ul.AssessmentPatt,
                learningFormatm2: ul.LearningForm2,
                assessmentPattm2: ul.AssessmentPattm2,
                carriculamTables: ul.CarriculamTables,
                selectedIndex: link
            });

        }, 5);
    }

    setSelectedClass(e, index) {
        e.preventDefault();
        this.setState({ IsActive: false });
        setTimeout(() => {
            this.setState({ selectedIndex: index, IsActive: true });
        }, 20);
    }

    render() {
        return (

            <div>
                <div class="row">

                    <div className={`cards ${this.props.streams.length <= 3 ? `AccordionSummaryCenter` : ``}`}>
                        <div className='tiles-box1'>
                            {
                                <Carousel itemsToShow={3} style={{ width: '80%' }} pagination={false} >
                                    {
                                        this.props.streams.filter(p => p.Display == true).map((p, i) => {
                                            return (
                                                
                                                <div  className={`divSubMenu ${this.state.selectedIndex === p.Stream ? `divSubMenu1` : ``}`} onClick={(e) => this.showAlert(e, p.Stream)} >
                                                    {p.Stream}
                                                </div>
                                            )
                                        })
                                    }
                                </Carousel>

                            }

                        </div>
                    </div>
                </div>
                {
                    this.state.IsActive === true ?
                        <div>
                            <div><center>
                           {/* {  <table width="80%" id='lformat'>
                                <thead>
                            <tr>
                                <th width="33%">Learning Delivery Model</th>
                                <th width="42%">Learning Duration & Format<font color="red"> *</font></th>
                                <th width="25%">Assessment Pattern</th>
                             </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td><b>Model 1 </b><br /> Project Work : Learning :: 80 : 20</td>
                                    <td>
                                        <ul class="b">
                                            {
                                                this.state.learningFormat && this.state.learningFormat.map((p) => {
                                                    return (<li>{p}</li>)
                                                })
                                            }
                                        </ul>
                                    </td>
                                    <td>
                                        <ul class="b">
                                            {
                                                this.state.assessmentPatt && this.state.assessmentPatt.map((p) => {
                                                    return (<li>{p}</li>)
                                                })
                                            }
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>Model 2</b><br/>Continuous full-time learning</td>
                                    <td>
                                        <ul class="b">
                                            {
                                                this.state.learningFormatm2 && this.state.learningFormatm2.map((p) => {
                                                    return (<li>{p}</li>)
                                                })
                                            }
                                        </ul>
                                    </td>
                                    <td>
                                        <ul class="b">
                                            {
                                                this.state.assessmentPattm2 && this.state.assessmentPattm2.map((p) => {
                                                    return (<li>{p}</li>)
                                                })
                                            }
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>Model 3</b><br/>Learning facilitated by Project; Assessments supported by LKM</td>
                                    <td>Project determined</td>
                                    <td>Project & LKM determined</td>
                                </tr>
                                </tbody>
                                <tfoot>
                                    <tr><td colspan="4">(<font color="red">*</font>Actual learning duration may vary by -/+ 1-5 days)</td></tr>
                                </tfoot>
                                </table> } */}</center>
                                {/* <div class="column1 left1 one_third">
                                    <b><span class="mySpancLass">Duration</span></b>
                                    <h3>
                                        <span>
                                            <ul class="b">
                                                <li>  {this.state.tectDuration}</li>
                                            </ul>
                                        </span>
                                    </h3>
                                </div>
                                <div class="column1 middle1 one_third">
                                    <b> <span class="mySpancLass"> Learning Format</span></b>
                                    <h3> <span class="mySpancLass1">
                                        <ul class="b">
                                            {
                                                this.state.learningFormat && this.state.learningFormat.map((p) => {
                                                    return (<li>{p}</li>)
                                                })
                                            }
                                        </ul>
                                    </span></h3>
                                </div>
                                <div class="column1 right1 one_third">
                                    <b> <span class="mySpancLass"> Assessment Pattern</span></b>
                                    <h3> <span class="mySpancLass1">
                                        <ul class="b">
                                            {
                                                this.state.assessmentPatt && this.state.assessmentPatt.map((p) => {
                                                    return (<li>{p}</li>)
                                                })
                                            }
                                        </ul>
                                    </span></h3>
                                </div> */}
                            </div>
                            <div class="AccordionSummaryCenterImage">
                                <ImageComponent ImageUrl={this.state.ImageUrl} />
                                <ImageComponent ImageUrl={this.state.ImageUrlm2} />
                            </div>
                            <br />
                            <br />
                            <CarriculamTable carriculamTables={this.state.carriculamTables} />
                            </div> : ""
                }
            </div>
        );
    }
}

export default SubMenuCards;